import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CaseListFilter } from '../../../../../../_base-shared/models/Case/CaseListFilter';
import { CaseService } from '../../case/case.service';
import { DistributionReportModalComponent } from '../distribution-report-modal/distribution-report-modal.component';
import { DistributionService } from '../distribution.service';

@Component({
  selector:    'app-distribution-report-list',
  templateUrl: './distribution-report-list.component.html',
  styles:      [],
})
export class DistributionReportListComponent implements OnInit {
  public caseListFilter: CaseListFilter;
  // tslint:disable-next-line:max-line-length

  public performanceReports: Array<{
    reportType: 'claims' | 'scheduled_fee' | 'payments_received',
    description: string,
    title: string,
    enabled: boolean,
    reportGroup: 'performance'
  }>;
  public fundingReports: Array<{
    reportType: 'funding_claims' | 'funding_schedule_fee' | 'pledge',
    description: string,
    title: string,
    enabled: boolean,
    reportGroup: 'funding'
  }>;

  public isLoading = 0;
  public casesCount: number;

  constructor(
    private translate: TranslateService,
    private toastr: ToastrService,
    private caseService: CaseService,
    private distributionService: DistributionService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.buildReportOptions();
    this.caseListFilter = {has_distribution: 1, select_all: 1, only_count: 1};
  }

  private buildReportOptions() {
    this.performanceReports = [
      {
        title:       'DISTRIBUTION.report.claims.label',
        description: null,
        reportType:  'claims',
        enabled:     true,
        reportGroup: 'performance',
      },
      {
        title:       'DISTRIBUTION.report.scheduled_fee.label',
        description: null,
        reportType:  'scheduled_fee',
        enabled:     true,
        reportGroup: 'performance',
      },
      {
        title:       'DISTRIBUTION.report.payments_received.label',
        description: null,
        reportType:  'payments_received',
        enabled:     true,
        reportGroup: 'performance',
      },
    ];

    this.fundingReports = [
      {
        title:       'DISTRIBUTION.report.funding_claims.label',
        description: null,
        reportType:  'funding_claims',
        enabled:     true,
        reportGroup: 'funding',
      },
      {
        title:       'DISTRIBUTION.report.funding_scheduled_fee.label',
        description: null,
        reportType:  'funding_schedule_fee',
        enabled:     true,
        reportGroup: 'funding',
      },
      {
        title:       'DISTRIBUTION.report.pledge_report.label',
        description: null,
        reportType:  'pledge',
        enabled:     true,
        reportGroup: 'funding',
      },
    ];
  }

  public openDistributionModal($event, reportType, reportGroup) {
    $event.preventDefault();
    console.log(reportType);
    const dialogRef = this.dialog.open(DistributionReportModalComponent, {
      width:  '50%',
      maxHeight: '100vh',
      data:   {
        reportType,
        reportGroup,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
}
